module.exports = __webpack_public_path__ + "static/media/logo.d5f30f19.png";